var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFulfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 99,
    viewBox: "0 0 376 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1598 98.3292C5.91453 98.3292 0 92.4147 0 85.1694C0 77.9241 5.91453 72.0095 13.1598 72.0095H26.3197V85.1694C26.3197 92.4147 20.4051 98.3292 13.1598 98.3292Z",
    fill: "#1B2F7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3821 65.7992H14.7863C6.65385 65.7992 0 59.2193 0 51.0129C0 42.8065 6.65385 36.2266 14.7863 36.2266H58.7017V61.0676C58.7017 69.1262 52.1218 75.7061 44.0633 75.7061H32.3821V65.7992Z",
    fill: "#1B2F7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6513 29.6466H14.7863C6.57992 29.6466 0 22.9928 0 14.8603C0 6.65385 6.65385 0 14.7863 0H91.971V24.841C91.971 32.8996 85.3911 39.4795 77.3325 39.4795H65.6513V29.6466Z",
    fill: "#1B2F7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.668 98.1918H121.544L121.544 0H180.802V15.184H137.668V43.0075H169.553V57.9228H137.668V98.1918Z",
    fill: "#1B2F7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.534 90.8439C221.949 93.149 220.503 94.2032 217.009 95.8157C213.605 97.4281 209.932 98.2344 205.991 98.2344C198.376 98.2344 192.329 95.7709 187.85 90.8439C183.461 85.9169 181.266 79.691 181.266 72.1662V43.0075H196.853V69.3444C196.853 73.7339 197.928 77.3171 200.078 80.0941C202.228 82.8712 205.543 84.2597 210.022 84.2597C214.411 84.2597 217.77 82.916 220.1 80.2285C222.518 77.5411 223.728 74.0026 223.728 69.6131V43.0075H239.315V84.394C239.315 88.3356 239.315 94.1121 239.315 98.2344H224.534C224.534 95.8241 224.534 93.7105 224.534 90.8439Z",
    fill: "#1B2F7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.717 97.9152H251.13V0.0207978H266.717V97.9152Z",
    fill: "#1B2F7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M315.255 14.3433C312.657 14.3433 310.373 15.1048 308.402 16.6277C306.521 18.061 305.58 20.614 305.58 24.2869V30.3541H320.764V43.9256H305.58V98.3258H289.859V43.9256H278.437V30.3541H289.859V23.8837C289.859 16.6277 291.964 10.8945 296.174 6.68413C300.385 2.47381 305.894 0.368652 312.702 0.368652C316.375 0.368652 319.107 0.816558 320.899 1.71237V15.0152C319.286 14.5673 317.405 14.3433 315.255 14.3433Z",
    fill: "#1B2F7C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M375.348 98.3254H359.761V0.389282H375.348V98.3254Z",
    fill: "#1B2F7C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M332.618 21.7355H348.041V37.1583H332.618V21.7355Z",
    fill: "#1B2F7C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M348.071 98.3291H332.618V43.929H348.071V98.3291Z",
    fill: "#1B2F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfil);
export default __webpack_public_path__ + "static/media/fulfil.83d6d92a7061179e2f2bbc14b276242d.svg";
export { ForwardRef as ReactComponent };